import { Auth } from 'aws-amplify';
import { throwError } from '../../ac/throwNotification';
import * as V from '../../constants/variables';

export const fetchCorrespondingMatrix = (period, setCorrespondingMatrixData, dispatch) => {
    Auth.currentSession().then(async session => {
        const token = session.getIdToken().getJwtToken();

        try {
            const url = `${V.API_GW_URL}/corresponding-matrix?period=${period}`;
            const response = await fetch(url, {
                headers: {
                    Authorization: token,
                },
            });
            if (response.ok) {
                try {
                    const json = await response.json();

                    // Validate the data structure
                    if (!json.locations || !Array.isArray(json.locations) ||
                        !json.flows || !Array.isArray(json.flows)) {
                        throw new Error('Invalid data structure: missing locations or flows arrays');
                    }

                    // Filter out invalid locations and flows
                    const validLocations = json.locations.filter(loc => loc &&
                        loc.id &&
                        ((loc.centroid && Array.isArray(loc.centroid) && loc.centroid.length === 2) ||
                         (loc.lon !== null && loc.lat !== null && !isNaN(loc.lon) && !isNaN(loc.lat)))
                    );
                    const validLocationIds = new Set(validLocations.map(loc => loc.id));
                    const validFlows = json.flows.filter(flow => flow &&
                        flow.origin &&
                        flow.dest &&
                        validLocationIds.has(flow.origin) &&
                        validLocationIds.has(flow.dest)
                    );

                    setCorrespondingMatrixData({
                        locations: validLocations,
                        flows: validFlows,
                    });
                } catch (err) {
                    dispatch(throwError(
                        err instanceof Error ?
                            err :
                            new Error(err?.message || err || 'Failed to load corresponding matrix')
                    ));
                }
            } else {
                const errorText = await response.text();
                const error = errorText?.startsWith('{') ? JSON.parse(errorText) : errorText;

                dispatch(throwError(new Error(error?.message || error || 'Failed to load corresponding matrix')));
            }
        } catch (err) {
            dispatch(throwError(
                err instanceof Error ?
                    err :
                    new Error(err?.message || err || 'Failed to load corresponding matrix')
            ));
        }
    });
};

